import { tWithKeyAttr as t } from "../../../i18nHelper";
import styles from "./companyProgramsPopup.module.css";
import { useGetCompanyAppointmentsProgramsMutation } from "../../../services/api/utils.api";
import React, { useEffect } from "react";
import { useAppSelector } from "../../../services/hooks";
import {
  appointmentsProgramsDataSelector,
  companyAppointmentsProgramsSelector,
} from "../../../services/selectors/utils.selectors";
import Loader from "../../loader/loader";
import { IAppointmentsProgram } from "../../../services/types/utils.types";
import { filterUniquePrograms } from "../../../utils/utils";

function CompanyProgramsPopup({
  companyId,
  onClick,
}: {
  companyId: number;
  onClick: (program: Partial<IAppointmentsProgram>) => void;
}) {
  const appointmentsPrograms = useAppSelector(
    companyAppointmentsProgramsSelector
  );
  const appointmentsProgramsData = useAppSelector(
    appointmentsProgramsDataSelector
  );

  const [getAppointmentsPrograms, { isLoading }] =
    useGetCompanyAppointmentsProgramsMutation();
  useEffect(() => {
    getAppointmentsPrograms({ companyId });
  }, [getAppointmentsPrograms, companyId]);
  const isValid = (a: any) => a !== undefined && a !== null && a !== 0;

  return (
    <article className={styles.popup}>
      {isLoading ? (
        <Loader />
      ) : appointmentsPrograms.length > 0 ? (
        <ul className={`options ${styles.options}`}>
          {filterUniquePrograms(appointmentsPrograms).map((a, index) => (
            <li
              key={index}
              className={`option ${styles.option}`}
              onClick={() => onClick(a)}
            >
              {a.name}
              <ul className={styles.option__content}>
                <li>{t('NAME')}<span className={styles.label}>{a.name}</span>
                </li>
                <li>
                  {t('MEETING_COUNT:')}{" "}
                  <span className={styles.label}>{a.countOfAppointments}</span>
                </li>
                <li>{t('PROFESSIONAL:')}<span className={styles.label}>
                    {appointmentsProgramsData.Roles.find(
                      (o) => o.value === a?.roleId
                    )?.label || a?.roleId}
                  </span>{" "}
                </li>
                <li>{t('FREQUENCY:')}<span className={styles.label}>
                    {appointmentsProgramsData.AppointmentsSequence.find(
                      (o) => o.value === a?.appointmentsSequenceId
                    )?.label || a?.appointmentsSequenceId}
                  </span>
                </li>
                <li>{t('MEETING_DURATION:')}<span className={styles.label}>
                    {appointmentsProgramsData.AppointmentsDurations.find(
                      (o) => o.value === a?.appointmentsDurationsId
                    )?.label || a?.appointmentsDurationsId}
                  </span>
                </li>
                <li>{t('TREATMENT_METHOD:')}<span className={styles.label}>
                    {appointmentsProgramsData.Medias.find(
                      (o) => o.value === a?.mediasId
                    )?.label || a?.mediasId}
                  </span>
                </li>
                {isValid(a.vetek) && (
                  <li>{t('SENIORITY:')}<span className={styles.label}>{a.vetek}</span>
                  </li>
                )}
                {isValid(a.genderId) && (
                  <li>{t('GENDER:')}<span className={styles.label}>
                      {appointmentsProgramsData.Genders.find(
                        (o) => o.value === a?.genderId
                      )?.label || a.genderId}
                    </span>
                  </li>
                )}
                {isValid(a.migzarId) && (
                  <li>{t('SECTOR:')}<span className={styles.label}>
                      {appointmentsProgramsData.Migzars.find(
                        (o) => o.value === a?.migzarId
                      )?.label || a.migzarId}
                    </span>
                  </li>
                )}
                {isValid(a.therapistsSpecializationsIds) && (
                  <li>{t('SPECIALTY:')}<span className={styles.label}>
                      {(() => {
                        const specializationIds = a.therapistsSpecializationsIds;
                        if (specializationIds && Array.isArray(specializationIds) && specializationIds.length > 0) {
                          const labels = appointmentsProgramsData.TherapistsSpecializations
                            .filter((o) => specializationIds.includes(Number(o.value)))
                            .map((o) => o.label);
                          return labels.length > 0 ? labels.join(', ') : specializationIds.join(', ');
                        }
                        return '';
                      })()}
                    </span>
                  </li>
                )}
                {a.comments && <li>{t('NOTES:')}{a.comments}</li>}
              </ul>
            </li>
          ))}
        </ul>
      ) : (
        <p className={"text"}>{t('NO_RESULTS')}</p>
      )}
    </article>
  );
}
export default CompanyProgramsPopup;
